import { setTelemetryUser } from "@socotec.io/socio-vue-components";
import { AgencyController } from "@socotec.io/socio-grpc-api/services/user_management/entities_pb";
import { useService } from "@/api/connectClient";

const agencyClient = useService(AgencyController);

let lastTelemetryUserKey = null;

const enrichWithAgencyGroup = async (oidcUser) => {
  const agencyCode = oidcUser.profile.codeSite;
  if (!agencyCode) return oidcUser;

  let agency = null;
  try {
    agency = await agencyClient.retrieveAgencyByCode({ code: agencyCode });
  } catch (err) {
    console.warn("[telemetry] Failed to retrieve agency by code:", err);
  }

  const agencyGroup = agency?.agencyGroup || {};
  return {
    ...oidcUser,
    profile: {
      ...oidcUser.profile,
      agencyGroup: agencyGroup.name,
      agencyGroupCode: agencyGroup.code,
    },
  };
};

export const setRapsotecTelemetryUser = async (
  oidcUser,
  userProfile,
  enableTelemetry,
) => {
  if (!oidcUser?.profile || !userProfile?.email) return;

  const telemetryUserKey = [
    userProfile.usermanagement_uuid,
    oidcUser.profile.codeSite || "",
  ].join(":");

  if (telemetryUserKey === lastTelemetryUserKey) return;

  const telemetryUser = await enrichWithAgencyGroup(oidcUser);
  setTelemetryUser(telemetryUser, enableTelemetry);
  lastTelemetryUserKey = telemetryUserKey;
};
